import { FormInput, Grid, FormGetter, FormSetter } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Typography, Divider, Paper } from '@mui/material';
import React from 'react';

import { FormButton } from 'components/FormButton';

import { FilesField } from '../FilesField';
import { StepWrapper } from '../StepWrapper';

type PaymentInfo = {
  voornaam: string;
  naam: string;
  bedrag: string;
};

export default function Step() {
  return (
    <StepWrapper
      name="Ontvangen onderhoudsuitkeringen"
      description="Gelieve volgende informatie in te vullen indien u het afgelopen jaar onderhoudsuitkeringen heeft ontvangen"
      maxWidth={1000}
    >
      <FormGetter
        names={['received_payments']}
        render={({ received_payments = [] }) => (
          <Grid container spacing={0}>
            <Grid xs={12} sx={{ mb: 2 }}>
              <FormSetter
                render={(setValue) => (
                  <FormButton
                    variant="outlined"
                    onClick={() => {
                      setValue('received_payments', [
                        ...received_payments,
                        {
                          voornaam: '',
                          naam: '',
                          bedrag: '',
                        },
                      ]);
                    }}
                    startIcon={<AddIcon />}
                  >
                    Uitkering toevoegen
                  </FormButton>
                )}
              />
            </Grid>

            {received_payments.map((payment: PaymentInfo, index: number) => (
              <Grid xs={12} key={index}>
                <Paper
                  elevation={1}
                  sx={{
                    p: 3,
                    mb: 2,
                    width: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.02)',
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <Typography variant="h6" color="primary">
                      Uitkering {index + 1}
                    </Typography>
                    <FormSetter
                      render={(setValue) => (
                        <FormButton
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => {
                            const newPayments = [...received_payments];
                            newPayments.splice(index, 1);
                            setValue('received_payments', newPayments);
                          }}
                          startIcon={<DeleteIcon />}
                        >
                          Verwijderen
                        </FormButton>
                      )}
                    />
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Grid container spacing={2}>
                    <Grid xs={12}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontSize: '0.875rem',
                          color: '#65748B',
                          fontWeight: 400,
                        }}
                      >
                        Schuldenaar van de onderhoudsuitkering
                      </Typography>
                    </Grid>

                    <FormInput
                      name={`received_payments.${index}.voornaam`}
                      label="Voornaam"
                      xs={12}
                      sm={6}
                      required
                    />
                    <FormInput
                      name={`received_payments.${index}.naam`}
                      label="Naam"
                      xs={12}
                      sm={6}
                      required
                    />
                    <Grid xs={12}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontSize: '0.875rem',
                          color: '#65748B',
                          fontWeight: 400,
                        }}
                      >
                        Ontvangen bedrag uitkering
                      </Typography>
                    </Grid>

                    <FormInput
                      name={`received_payments.${index}.bedrag`}
                      label="Bedrag"
                      xs={12}
                      sm={6}
                      required
                    />

                    <FilesField
                      name={`received_payments.${index}.documenten`}
                      title="Upload hier alle fiches/attesten/bankuittreksels ivm ontvangen onderhoudsuitkeringen"
                      xs={12}
                      md={12}
                    />
                  </Grid>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}
      />
    </StepWrapper>
  );
}
